import { EMPLOYEE_PROFILE_STEPS } from '../people/types';
import type { ReadinessItem } from './types';

/** Items the Employee Profile can actually edit in this release (First/Last Name via Personal
 * Information; Employment Type via Work Details, EPN-186). It is presentation only — it picks the link's wording ("Edit" vs "View section") so the
 * summary never implies an item can be fixed where it cannot yet. It plays no part in readiness. Extend it
 * as later slices make more fields editable. */
export const EDITABLE_ITEM_KEYS: ReadonlySet<string> = new Set([
  'employee.first-name', 'employee.last-name', 'employment.employment-type', 'compensation.pay-type', 'compensation.pay-rate',
]);

const KNOWN_STEPS: ReadonlySet<string> = new Set(EMPLOYEE_PROFILE_STEPS.map((s) => s.key));

export function destinationPath(employeeId: string, item: ReadinessItem): string | null {
  if (!item.destinationStep || !KNOWN_STEPS.has(item.destinationStep)) return null;
  const section = item.destinationSection ? `?section=${encodeURIComponent(item.destinationSection)}` : '';
  return `/people/${employeeId}/${item.destinationStep}${section}`;
}

